import StackedMapMod from './stackedMap.js';
const MODULE_NAME = 'ui.bootstrap.module.stackedMap';
let compMod = angular.module(MODULE_NAME, [StackedMapMod]);
export default compMod = compMod.name;
